<template>
  <div class="compare-box-item flex flex-justify-between ">
    <div class="compare-box">
      <div class="compare-title">
        标准货运业务
      </div>
      <a class="compare-btn" href="https://open.huolala.cn/#/doc/api?menu=9&type=3&id=15">个人版API接入
      </a>
      <ul class="compare-list">
        <li class="list-item">接口标准化程度高</li>
        <li class="list-item">业务流程清晰，便捷</li>
        <li class="list-item">有竞争力的服务价格</li>
      </ul>
      <div class="compare-tips">
        同步执行货拉拉APP价格策略
      </div>
      <div class="compare-btn2">适用场景：</div>
      <div class="compare-case">
        第三方平台/ERP软件商
        <br/>
        ISV服务商/企业自用车
      </div>
    </div>
    <div class="compare-img"></div>
    <div class="compare-box">
      <div class="compare-title">
        企业版货运业务
      </div>
      <a class="compare-btn" href="https://open.huolala.cn/#/doc/api?menu=9&type=2&id=4">企业版API接入</a>
      <ul class="compare-list">
        <li class="list-item">专业用车，定制化服务</li>
        <li class="list-item">提供免费货保，增值税发票</li>
        <li class="list-item">先用车，后付款——可申请免息账期</li>
      </ul>
      <div class="compare-tips">
        同步执行货拉拉企业版价格策略
      </div>
      <div class="compare-btn2">适用场景：</div>
      <div class="compare-case">
        定制化服务需求的中大型企业
        <br/>
        3PL供应商
      </div>
    </div>
  </div>
</template>
<script>

import {loginPath} from "../../assets/js/common";

export default {
  data() {
    return {}
  },
  methods: {
    toLogin() {
      return loginPath()
    }
  }
}

</script>
<style lang="scss" scoped>
.compare-box-item {
  width: 100%;
  padding: 107px 12px 93px 0;
  color: #fff;
  background: #292f3e url('../../assets/img/index/ic_net.png') bottom no-repeat;
  background-size: cover;
  box-sizing: border-box;
}

.compare-box {
  .compare-title {
    width: 160px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  .compare-btn {
    display: inline-block;
    width: 160px;
    margin-left: -2px;
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background: #ff5a00;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      box-shadow: 4px 4px 0 #9e3b05;
    }
  }

  .compare-list {
    margin-top: 36px;
  }

  .list-item {
    margin-bottom: 20px;
    font-size: 12px;

    &:before {
      content: '';
      display: inline-block;
      position: relative;
      top: -2px;
      width: 4px;
      height: 4px;
      margin-right: 5px;
      border-radius: 50%;
      background: #fff;
      vertical-align: middle;
    }
  }

  .compare-tips {
    margin: 40px 0;
  }

  .compare-btn2 {
    display: inline-block;
    padding: 0 7px;
    line-height: 22px;
    color: #2d3444;
    background: #fff;
  }

  .compare-case {
    margin-top: 12px;
    line-height: 20px;
  }
}

.compare-img {
  display: inline-block;
  width: 376px;
  height: 283px;
  margin-top: 44px;
  margin-right: 20px;
  background: url('../../assets/img/index/ic_intro.png') no-repeat;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/index/compare.vue